import { render, staticRenderFns } from "./GroupsEdit.vue?vue&type=template&id=5f4743bd&scoped=true&"
import script from "./GroupsEdit.vue?vue&type=script&lang=js&"
export * from "./GroupsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4743bd",
  null
  
)

export default component.exports